export default "__VITE_ASSET__VsrIyZpx__"